import type { WaveGalleryLayout } from "../components/library/WaveThreadGallery";

const STORAGE_KEY = "wave.gallery.layout";

export function loadGalleryLayout(): WaveGalleryLayout {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "grid" || raw === "list") return raw;
  } catch {
    /* ignore */
  }
  return "grid";
}

export function saveGalleryLayout(layout: WaveGalleryLayout): void {
  try {
    localStorage.setItem(STORAGE_KEY, layout);
  } catch {
    /* ignore */
  }
}
